export const getMultiPositionsToSinglePosition = positions => {
    return positions.reduce((acc, pos) => {
        // Split multi positions by '/' and map.  example 'SP'/'RP' to 'P' or WR/RB to 'WR' and 'RB'
        if (typeof(pos) === 'string') {
            pos && pos.split('/').forEach(p => {
                const trimmedPos = p.trim();
                const position = (trimmedPos === 'SP' || trimmedPos === 'RP') ? 'P' : trimmedPos; // mlb to pitchers

                if (!acc.includes(position)) {
                    acc.push(position);
                }
            });
        }
        return acc;
    }, []);
};